export const FILESPACE_ROOT_ID = '';
export const PATH_SEPARATOR = '/';
export const ROOT_DIR_PATH = '';
